import { getDarkenColor, getLightenColor } from "./"

export default (type, colors) => {
  const styles = {
    default: {
      "site-footer": {
        background: "transparent"
      },
      "c-comment__footer": {
        customCSS: `
          .c-comment__footer ul li a {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              2
            )} 50%);
          }
          .c-comment__footer ul li a:hover,
          .c-comment__footer ul li a:active, 
          .c-comment__footer ul li a:focus {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              0.15
            )} 50%);
          }  
          .c-comment__footer ul li:before  {
            color: ${colors.offgray_mid};
          }
        `
      },
      "site-footer__nav-link": {
        customCSS: `
          .site-footer__nav-link {
            color: ${colors.secondary_dark};
          }
          .site-footer__nav-link:hover,
          .site-footer__nav-link:active, 
          .site-footer__nav-link:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      }
    },
    type1: {
      "site-footer": {
        fontFamily: "Helvetica-Neue-LT-Std",
        background: colors.light
      },
      "site-footer-inner": {
        height: "110px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        customCSS: `
          .site-footer-inner:before, 
          .site-footer-inner:after {
            display: none;
          }
          .view--has-chrome .site-footer-inner {
            margin-top: 0;
          }
        `
      },
      "site-footer__nav": {
        display: "flex"
      },
      "site-footer__nav--social": {
        customCSS: `
          .site-footer__nav--social li a {
            margin-right: 20px;
          }
          .site-footer__nav--social a:not(:hover) {
            color: ${colors.secondary};
          }
          .site-footer__nav--social li:last-of-type a {
            margin-right: 0;
          }
        `
      },
      "site-footer__col": {
        width: "auto",
        margin: 0,
        customCSS: `
          .site-footer__col:before {
            border-top: none;
          }
        `
      },
      "site-footer__nav-link": {
        margin: "0 20px",
        fontSize: "14px",
        letterSpacing: "normal",
        customCSS: `
          .site-footer__nav-link {
            color: ${colors.secondary_dark};
          }
          .site-footer__nav-link:hover {
            color: ${colors.primary};
          }
          .site-footer__nav-link:not(:hover) {
            color: ${getDarkenColor(colors.primary, 0.17)};
          }
        `
      },
      "site-footer__col--copyright": {
        fontSize: "12px",
        color: "#C4C4C4"
      },
      "site-footer__col--copyright-p": {
        margin: 0
      },
      "c-comment__footer": {
        customCSS: `
          .c-comment__footer ul li a {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              2
            )} 50%);
          }
          .c-comment__footer ul li a:hover,
          .c-comment__footer ul li a:active, 
          .c-comment__footer ul li a:focus {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              0.15
            )} 50%);
          }  
          .c-comment__footer ul li:before  {
            color: ${colors.offgray_mid};
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/siteFooter.js